<script>
export default {
  name: "breadcrumbAccountSection"
};
</script>

<template>
  <el-row style="padding: 8px 16px 8px 16px; background-color: #ffffff">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/homepage' }"
          >Homepage</el-breadcrumb-item
        >
        <el-breadcrumb-item>Account</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
  </el-row>
</template>

<style scoped>
.el-breadcrumb__item /deep/ .el-breadcrumb__separator {
  color: #003333;
  font-weight: 600;
}

.el-breadcrumb__item /deep/ .el-breadcrumb__inner {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/breadcrumbAccountSection.vue